export default __webpack_public_path__ + "8ca86a8fa0c67b10ba07a1bdd92584b9.png";